import firebase from '@/firebase';
import store from '@/store/index';
import db from '@/db';
//import router from '@/router';

firebase.auth().onAuthStateChanged((user) => {
  // if (user.user) {
  //   /* eslint-disable */
  //   user = user.user;
  //   /* eslint-enable */
  // }
  // const setUser = {
  //   id: user.uid,
  //   name: user.displayName,
  //   image: user.photoURL,
  //   created_at: firebase.firestore.FieldValue.serverTimestamp(),
  // };
  // db.collection('users').doc(setUser.id).set(setUser, {
  //   merge: true
  // });
  // store.commit('auth/setUser', setUser);
  if ((user && user.emailVerified) || (user && user.email.includes('mymeatloaf.com'))) {
    if (user.user) {
      /* eslint-disable */
      user = user.user;
      /* eslint-enable */
    }
    let created_at;
    let name;
    let image;
    let notifications = [];
    db.collection("users").doc(user.uid).get().then(docSnapshot => {
      if (docSnapshot.exists) {
        name = docSnapshot.data().name;
        image = docSnapshot.data().image;
        created_at = docSnapshot.data().created_at;
        
      db.collection("users")
        .doc(user.uid)
        .collection("notifications")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            notifications.push(doc.data());
          });
        });
      }
      else {
        name = user.displayName;
        created_at = new Date()
      }
      const setUser = {
        id: user.uid,
        name: name,
        image: image,
        created_at: created_at,
        notifications: notifications
      };
      db.collection('users').doc(setUser.id).set(setUser, {
        merge: true
      });
      store.commit('auth/setUser', setUser);
    });
    
    
  } else {
    store.commit('auth/setUser', null);
  }
});
